module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistics"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('h2', [_c('em'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("stats.title")))])])]), _vm._v(" "), _c('section', {
    staticClass: "chart-container"
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.apikey),
      callback: function($$v) {
        _vm.apikey = $$v
      },
      expression: "apikey"
    }
  }, _vm._l((_vm.projects), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }, _vm._l((_vm.periods), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.network),
      callback: function($$v) {
        _vm.network = $$v
      },
      expression: "network"
    }
  }, _vm._l((_vm.networks), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "comCont clumW",
    attrs: {
      "span": 23,
      "empty-text": _vm.$t('common.noData')
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartLine"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "comCont clum",
    attrs: {
      "empty-text": _vm.$t('common.noData')
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartPie"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "comCont clum"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartBar"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "comCont clum"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartHeatmap"
    }
  })])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43cef086"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Statistics/Statistics.vue
// module id = 980
// module chunks = 1